module.exports = __webpack_public_path__ + "img/full1-min.5f2f207b.png";